import http from "@/http/axios";
import { appModule } from "@/store/modules/app";

export async function getSchedulerInfo() {
    const result = await http.get("/scheduler");
    if(result) {
        if (result.status === 200) {
            return result.data;
        }
    }
    appModule.sendErrorNotice("取得Scheduler資訊失敗");
}

export async function getSchedulerJobList() {
    const result = await http.get("/scheduler/jobs");
    if(result) {
        if (result.status === 200) {
            return result.data;
        }
    }
    appModule.sendErrorNotice("取得Scheduler Jobs列表失敗");
}

export async function getSchedulerJob(job_id) {
    const result = await http.get("/scheduler/jobs/" + job_id);
    if(result) {
        if (result.status === 200) {
            return result.data;
        }
    }
    appModule.sendErrorNotice("取得Scheduler Job失敗");
}

export async function pauseSchedulerJob(job_id) {
    const result = await http.post("/scheduler/jobs/" + job_id + "/pause");
    if(result) {
        if (result.status === 200) {
            appModule.sendSuccessNotice("暫停成功");
            return;
        }
    }
    appModule.sendErrorNotice("暫停失敗");
}

export async function resumeSchedulerJob(job_id) {
    const result = await http.post("/scheduler/jobs/" + job_id + "/resume");
    if(result) {
        if (result.status === 200) {
            appModule.sendSuccessNotice("回復執行成功");
            return;
        }
    }
    appModule.sendErrorNotice("回復執行失敗");
}

export async function runSchedulerJob(job_id) {
    const result = await http.post("/scheduler/jobs/" + job_id + "/run");
    if(result) {
        if (result.status === 200) {
            appModule.sendSuccessNotice("執行成功");
            return;
        }
    }
    appModule.sendErrorNotice("執行失敗");
}

export async function modifySchedulerJob(job_id, body) {
    console.log(body);
    const result = await http.patch("/scheduler/jobs/" + job_id, body);
    if(result) {
        if (result.status === 200) {
            appModule.sendSuccessNotice("修改成功");
            return;
        }
    }
    appModule.sendErrorNotice("修改失敗");
}

export async function addSchedulerJob(body) {
    const result = await http.post("/scheduler/jobs", body);
    if(result) {
        if (result.status === 200) {
            appModule.sendSuccessNotice("新增成功");
            return;
        }
    }
    appModule.sendErrorNotice("新增失敗");
}

export async function removeSchedulerJob(job_id) {
    const result = await http.delete("/scheduler/jobs/" + job_id);
    if(result) {
        if (result.status === 204) {
            appModule.sendSuccessNotice("刪除成功");
            return;
        }
    }
    appModule.sendErrorNotice("刪除失敗");
}